module.exports = __webpack_public_path__ + "img/pisa.748026b0.jpg";